<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มประเภทบัตร</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ cardTypeInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ cardTypeInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสประเภทบัตร
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="cardType.card_type_code"
          :rules="[(v) => !!v || 'โปรดระบุรหัสประเภทบัตร']"
          required
          clearable
          @change="checkEmpty($event, 'card_type_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ประเภทบัตร (ไทย)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="cardType.title_th"
          :rules="[(v) => !!v || 'โปรดระบุประเภทบัตร']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ประเภทบัตร (อังกฤษ)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="cardType.title_en"
          :rules="[(v) => !!v || 'โปรดระบุประเภทบัตร']"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          ข้อมูลอิเล็กทรอนิกส์ (ค่าเริ่มต้น)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          v-model="cardType.default_card_identifier_type_code"
          :items="cardIdentifierTypes"
          :rules="[(v) => !!v || 'โปรดระบุชนิดข้อมูลอิเล็กทรอนิกส์']"
          item-text="title"
          item-value="card_identifier_type_code"
          outlined
          dense
        >
        </v-autocomplete>
        <v-checkbox
          v-model="cardType.is_default_for_employee_card"
          hide-details
        >
          <template v-slot:label>
            <span class="body-2"
              >ใช้ประเภทบัตรนี้เป็นค่าเริ่มต้นสำหรับบัตรพนักงาน (Employee
              Card)</span
            >
          </template>
        </v-checkbox>
        <!-- <div
          v-show="cardType.is_default_for_employee_card"
          class="mt-1 caption red--text"
        >
          กรณีเลือกค่าเริ่มต้น ถ้ามีค่าเริ่มต้นเดิมอยู่แล้ว
          ค่าเริ่มต้นนี้จะเป็นค่าเริ่มต้นใหม่
        </div> -->
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isCardTypeDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card_type:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card_type:create')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card_type:update')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    cardType: {
      type: Object,
      required: true,
    },
    cardTypeInit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cardIdentifierType: null,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isCardTypeDataChange() {
      if (
        this.cardType.card_type_code !== this.cardTypeInit.card_type_code ||
        this.cardType.title_th !== this.cardTypeInit.title_th ||
        this.cardType.title_en !== this.cardTypeInit.title_en ||
        this.cardType.default_card_identifier_type_code !==
          this.cardTypeInit.default_card_identifier_type_code ||
        this.cardType.is_default_for_employee_card !==
          this.cardTypeInit.is_default_for_employee_card
      ) {
        this.$emit('isCardTypeDataChange', true)
        return true
      }
      this.$emit('isCardTypeDataChange', false)
      return false
    },
    cardIdentifierTypes() {
      return this.$store.state.card.cardIdentifierTypes
    },
  },
  created() {
    this.fetchCardIdentifierTypes()
  },
  methods: {
    ...mapActions({
      addCardType: 'card/addCardType',
      editCardType: 'card/editCardType',
      deleteCardType: 'card/deleteCardType',
      fetchCardIdentifierTypes: 'card/fetchCardIdentifierTypes',
      fetchCardTypes: 'card/fetchCardTypes',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.cardType[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบประเภทบัตร',
        value: `${this.cardType.title_th}`,
        item: this.cardType,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(cardType) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteCardType({
        company_uuid,
        card_type_uuid: cardType.card_type_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.resetValidation()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      try {
        if (this.$refs.form.validate()) {
          this.$store.state.loading = true

          const cardType = {
            card_type_code: this.cardType.card_type_code,
            title_th: this.cardType.title_th,
            title_en: this.cardType.title_en,
            default_card_identifier_type_code:
              this.cardType.default_card_identifier_type_code,
            is_default_for_employee_card:
              this.cardType.is_default_for_employee_card,
          }

          const { company_uuid } = this.$store.state.authentication.company

          await this.addCardType({
            company_uuid,
            body: cardType,
          })
          await this.fetchCardTypes({ company_uuid })

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.resetValidation()
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async onSave() {
      try {
        if (this.$refs.form.validate()) {
          this.$store.state.loading = true

          const cardType = {
            card_type_uuid: this.cardType.card_type_uuid,
            card_type_code: this.cardType.card_type_code,
            title_th: this.cardType.title_th,
            title_en: this.cardType.title_en,
            default_card_identifier_type_code:
              this.cardType.default_card_identifier_type_code,
            is_default_for_employee_card:
              this.cardType.is_default_for_employee_card,
          }

          const { company_uuid } = this.$store.state.authentication.company

          await this.editCardType({
            company_uuid,
            card_type_uuid: this.cardType.card_type_uuid,
            body: cardType,
          })
          await this.fetchCardTypes({ company_uuid })

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.resetValidation()
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    onClose() {
      if (this.isCardTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.resetValidation()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.resetValidation()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        this.$emit('onReset', this.formAction)
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
